import React, { useRef } from "react";
import Image from "../Image";
import Select from "../../form/Select";
import Button from "../../form/Button";
import Textarea from "../../form/Textarea";
import Input from "../../form/Input";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import TableAction from "./TableAction";
import Checkbox from "../../form/Checkbox";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { PDFDownloadLink, Document, pdf } from "@react-pdf/renderer";
import InformationReport from "../../../pages/pdf/InformationReport";

import { useTranslation } from "react-i18next";
import { classNames } from "../../../helper/classNames";
import Indentification from "../Indentification";
import { initialsValue } from "../../../helpers";
import { Tooltip } from "react-tooltip";

const Td = ({
  type,
  width,
  align,
  data,
  value,
  image,
  tdClasses,
  statusLabel,
  statusType,
  isDropdoen,
  statusClasses,
  inputType,
  inputClasses,
  inputPlaceholder,
  rowId,
  userIds,
  editUrl,
  isStatusUpdate,
  isDeleteEnabled,
  dragHandleProps,
  getActionValue = () => {},
  isUser,
  detailsUrl,
  othersAction = () => {},
  loginAs,
  isColor = "",
  extraData,
  shortName,
  isTooltip,
  toolTipData,
  updateCheckboxHandler = () => {},
  ischeckboxData = false,
  checkboxData,
  ...props
}) => {
  const user = useSelector((state) => state.auth?.user);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const flatPicker = useRef(null);
  const status = {
    success: "bg-green-100 text-green-600",
    danger: "bg-rose-100 text-rose-600",
    warning: "bg-amber-100 text-amber-600",
    info: "bg-sky-100 text-sky-600",
    "same-success": "bg-lime-100 text-lime-600",
    "": "bg-slate-100 text-slate-600",
  };

  const getDownload = async (e) => {
    e.preventDefault();
    if (e.target.tagName.toLowerCase() === "a") {
      window.open(e.target.href, "_blank");
    }
  };

  const salesReportHeading = [
    {
      name: t("company_name"),
      option: "",
    },
    {
      name: t("company_administrator"),
      option: "",
    },
    {
      name: t("administrator_position"),
      option: "",
    },
    {
      name: t("company_administrator_email"),
      option: "",
    },
    {
      name: t("company_administrator_phone"),
      option: "",
    },
    {
      name: t("company_size"),
      option: "",
    },
    {
      name: t("price"),
      option: "",
    },
    {
      name: t("source"),
      option: "",
    },
    {
      name: t("price_note"),
      option: "",
    },
    {
      name: t("salesperson"),
      option: "",
    },
    {
      name: t("Salesperson Email"),
      option: "",
    },
    {
      name: "Proposed Contract Length",
      option: "",
    },
    {
      name: "Payment Terms",
      option: "",
    },
    {
      name: t("additional_notes"),
      option: "",
    },
    {
      name: t("purchase_agreement_received"),
      option: "",
    },
    {
      name: t("account_setup_completed"),
      option: "",
    },
    {
      name: t("invoice_and_w_9_sent"),
      option: "",
    },
    {
      name: t("payment_received"),
      option: "",
    },
    {
      name: t("training_scheduled"),
      option: "",
    },
    {
      name: t("training_completed"),
      option: "",
    },
    {
      name: t("plans"),
      option: "",
    },
  ];

  const handleDownloadClick = async (e) => {
    e.preventDefault();

    // Open a blank tab immediately to avoid pop-up blockers.
    const newTab = window.open("", "_blank");

    // Display a styled loading message with Tailwind CSS.
    newTab.document.write(`
        <html lang="en">
          <head>
            <script src="https://cdn.tailwindcss.com"></script>
            <style>
              body {
                @apply bg-gray-100;
                margin: 0;
                height: 100vh;
              }
              .loader-container {
                @apply flex flex-col justify-center items-center h-screen;
              }
              .loader {
                width: 50px;
                aspect-ratio: 1;
                display: grid;
                border-radius: 50%;
                background:
                  linear-gradient(0deg, rgb(0 0 0 / 50%) 30%, #0000 0 70%, rgb(0 0 0 / 100%) 0) 50% / 8% 100%,
                  linear-gradient(90deg, rgb(0 0 0 / 25%) 30%, #0000 0 70%, rgb(0 0 0 / 75%) 0) 50% / 100% 8%;
                background-repeat: no-repeat;
                animation: l23 1s infinite steps(12);
              }
              .loader::before,
              .loader::after {
                content: "";
                grid-area: 1 / 1;
                border-radius: 50%;
                background: inherit;
                opacity: 0.915;
                transform: rotate(30deg);
              }
              .loader::after {
                opacity: 0.83;
                transform: rotate(60deg);
              }
              @keyframes l23 {
                100% {
                  transform: rotate(1turn);
                }
              }
            </style>
          </head>
          <body>
            <div class="flex justify-center items-center mt-20 loader-container">
            <div class="flex flex-col items-center justify-center space-y-4">
              <div class="loader"></div>
              <p class="text-teal-700 text-lg font-semibold mt-4">Generating your PDF... Please wait.</p>
            </div>
           </div>
          </body>
        </html>
        `);
    try {
      // Generate the PDF blob asynchronously.
      const blob = await pdf(
        <Document>
          <InformationReport
            details={props?.info}
            user={user}
            heading={salesReportHeading}
          />
        </Document>
      ).toBlob();

      // Create a URL from the blob.
      const blobURL = URL.createObjectURL(blob);
      // Redirect the new tab to the blob URL (load the PDF).
      newTab.location.href = blobURL;
    } catch (error) {
      // Display an error message in the new tab.
      newTab.document.body.innerHTML = `
          <div class="flex flex-col items-center justify-center h-screen bg-red-100">
            <p class="text-red-700 text-lg font-semibold">Failed to load PDF. Please try again later.</p>
            <p class="text-sm text-gray-600">${error.message}</p>
          </div>
        `;
      console.error("PDF generation error:", error);
    }
  };
  return (
    <td
      className={classNames(
        "py-2 px-2 text-left max-w-[240px] border-b border-slate-200 break-all",
        tdClasses,
        align === "right"
          ? "text-right"
          : align === "center"
          ? "text-center"
          : ""
      )}
      style={{ minWidth: width + "%" }}
      {...dragHandleProps}
    >
      {type === "checkbox" && props?.isCheckbox ? (
        <>
          <Checkbox
            checkboxName={rowId}
            isChecked={data && data === 1 ? true : false}
            checkboxValue={value}
            getCheckboxValue={(code, event) => {
              updateCheckboxHandler({
                id: rowId,
                checkboxId: data,
                code: props?.code ? props?.code : "",
                isEnabled: event.target.checked,
              });
            }}
          />
        </>
      ) : value && value === 2 ? (
        <Checkbox
          checkboxName={rowId}
          //isChecked={(data)?true:false}
          checkboxValue={value}
          getCheckboxValue={(code, event) => {
            updateCheckboxHandler({
              id: rowId,
              checkboxId: data,
              code: props?.code ? props?.code : "",
              isEnabled: event.target.checked,
            });
          }}
          //isDisabled={true:false}
        />
      ) : (
        ""
      )}

      {(type === "checkboxText" && props?.isCheckbox) ||
      (ischeckboxData && value === 2) ? (
        <>
          <div className="flex items-center gap-1">
            <Checkbox
              checkboxName={rowId}
              isChecked={data && data === 1 ? true : false}
              checkboxValue={value}
              getCheckboxValue={(code, event) => {
                updateCheckboxHandler({
                  id: rowId,
                  checkboxId: data,
                  code: props?.code ? props?.code : "",
                  isEnabled: event.target.checked,
                });
              }}
            />
            {ischeckboxData && checkboxData}
          </div>
        </>
      ) : (
        ""
      )}

      {type === "link" && (
        <Link
          to={value}
          className="flex text-sm font-normal text-slate-600   hover:translate-x-2 transition-all duration-200"
          target="_blank"
        >
          {data}
        </Link>
      )}
      {type === "text" && (
        <div className={"text-sm font-normal text-slate-600 " + isColor}>
          {data}
        </div>
      )}
      {type === "user" && (
        <>
          {!isTooltip ? (
            <div
              className="relative flex items-center cursor-pointer"
              onClick={() => navigate(data?.link)}
            >
              {/* <div className="w-8 h-8 min-w-[32px] overflow-hidden rounded-full border border-slate-200">
              <Image src={image} alt={'data'} width={'100%'} height={'100%'} effect={'blur'} classes={'object-cover'}/>
            </div> */}
              <Indentification
                initial={initialsValue(shortName)}
                image={image}
                alt={shortName}
                fill={true}
                className={""}
                size={"sm"}
              />
              <div
                className={
                  "text-sm font-normal text-slate-600 mx-2 break-words " +
                  isColor
                }
              >
                {data}
              </div>
            </div>
          ) : (
            <div
              className="relative inline-flex items-center cursor-pointer"
              data-tooltip-id={`userName${data?._id}`}
              data-tooltip-place="right"
              onClick={() => navigate(data?.link)}
            >
              <Indentification
                initial={initialsValue(shortName)}
                image={image}
                alt={shortName}
                fill={true}
                className={""}
                size={"sm"}
              />
              <div
                className={
                  "text-sm font-normal text-slate-600 mx-2 break-words " +
                  isColor
                }
              >
                {data?.name}
              </div>
              <Tooltip
                id={`userName${data?._id}`}
                className="!text-xs !bg-teal-500 z-50 shadow-lg rounded py-2 px-2 !opacity-100"
                render={() => toolTipData}
              />
            </div>
          )}
        </>
      )}
      {type === "text-tooltip" && (
        <div
          className="relative inline-flex items-center"
          data-tooltip-id={`statusTooltip${data?._id}`}
          data-tooltip-place="right"
        >
          <div className={"text-sm font-normal text-slate-600 mx-2 " + isColor}>
            {data?.name}
          </div>
          {isTooltip && (
            <Tooltip
              id={`statusTooltip${data?._id}`}
              className="!text-xs !bg-teal-500 z-50 shadow-lg rounded py-2 px-2 !opacity-100"
              render={() => toolTipData}
            />
          )}
        </div>
      )}
      {type === "image" && (
        <div className="w-8 h-8 min-w-[32px] overflow-hidden rounded-full border border-slate-200">
          <Image
            src={image}
            alt={"data"}
            width={"100%"}
            height={"100%"}
            effect={"blur"}
            classes={"object-cover"}
          />
        </div>
      )}

      {type === "textImage" && (
        <div className="w-8 h-8 overflow-hidden bg-slate-200 text-slate-600 rounded-full relative flex items-center justify-center border border-white font-semibold text-xs">
          {data}
        </div>
      )}

      {type === "status" && (
        <div
          className={classNames(
            "flex items-center",
            align === "right"
              ? "justify-end"
              : align === "center"
              ? "justify-center"
              : ""
          )}
          data-tooltip-id={`textTooltip${data?._id}`}
          data-tooltip-place="right"
        >
          <div
            className={
              "text-[10px] font-medium leading-tight rounded py-1 px-2 " +
              status[statusType]
            }
          >
            {statusLabel}
          </div>
          {toolTipData && (
            <Tooltip
              id={`textTooltip${data?._id}`}
              className="!text-xs !bg-teal-500 z-50 shadow-lg rounded py-2 px-2 !opacity-100"
              render={() => toolTipData}
            />
          )}
        </div>
      )}
      {type === "button" && !props?.isExist && (
        <Button
          buttonLabel={props?.buttonLabel}
          buttonClasses={
            "!bg-amber-50 !text-amber-600  !text-xs !gap-1 py-1 px-2 !h-auto"
          }
          buttonLabelClasses={"!text-xs !leading-tight"}
          //buttonClasses={"!h-auto !p-0 !bg-transparent !text-slate-500 !text-xs"}
          buttonType={"button"}
          buttonIcon={"fa-regular " + props?.buttonIcon}
          buttonIconPosition={"left"}
          buttonHasLink={props?.buttonHasLink}
          functions={() => {
            getActionValue({
              button_type: "others",
              row_id: rowId,
              current_status: 1,
            });
          }}
        />
      )}
      {type === "action" && (
        <div className="flex items-center justify-end">
          {!isDropdoen && isDropdoen !== undefined ? (
            <Button
              buttonLabel={t("edit")}
              buttonClasses={"!text-xs"}
              //buttonClasses={"!h-auto !p-0 !bg-transparent !text-slate-500 !text-xs"}
              buttonType={"button"}
              buttonIcon={"fa-regular fa-pen-to-square"}
              buttonIconPosition={"left"}
              buttonHasLink={false}
              functions={() => {
                getActionValue({
                  button_type: "others",
                  row_id: rowId,
                  current_status: 1,
                });
              }}
            />
          ) : (
            <TableAction
              xPlacement={"right"}
              rowId={rowId}
              userIds={userIds}
              editUrl={editUrl}
              isStatusUpdate={isStatusUpdate}
              isDeleteEnabled={isDeleteEnabled}
              isStatusLabel={statusLabel}
              isStatusType={statusType}
              getActionValue={(obj) => getActionValue(obj)}
              isUser={isUser}
              detailsUrl={detailsUrl}
              othersAction={othersAction}
              data={data}
              loginAs={loginAs}
              isDropdoen={isDropdoen}
              extraData={extraData}
            />
          )}
        </div>
      )}
      {type === "report" && (
        <button
          type={"button"}
          className={
            "text-[10px] font-medium leading-tight rounded py-1 px-2 bg-blue-200 text-blue-800 flex gap-1 items-center"
          }
          onClick={(e) => handleDownloadClick(e)}
        >
          <i className={"fa-fw fa-regular fa-circle-info"}></i>
          <div className={"text-xs font-semibold whitespace-nowrap"}>
            {t("info")}
          </div>
        </button>
      )}
      {type === "select" && (
        <Select
          xPlacement={"left"}
          dropdownClass={"!w-full"}
          dropdownData={[
            { _id: -1, label: "Select", value: 0 },
            ...[
              { _id: 1, label: "Yes", value: 1 },
              { _id: 2, label: "No", value: 2 },
            ],
          ]}
        />
      )}
      {type === "date" && (
        <Flatpickr
          ref={flatPicker}
          className="w-full h-10 rounded bg-slate-50 border border-slate-200 px-3 text-sm text-slate-600 !ring-0 !outline-0 focus:border-gray-400 transition-all duration-200"
          placeholder={""}
        />
      )}
      {type === "input" && <Input inputType={"text"} />}
      {type === "textarea" && <Textarea />}
    </td>
  );
};

export default Td;
